import { render } from "./page-content.vue?vue&type=template&id=5302904a&scoped=true"
import script from "./page-content.vue?vue&type=script&lang=js"
export * from "./page-content.vue?vue&type=script&lang=js"

import "./page-content.vue?vue&type=style&index=0&id=5302904a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5302904a"]])

export default __exports__